import styles from './event.module.sass'

import classNames from 'classnames'
import each from 'lodash/each'

import library from '../library'

import Image from '../basic/image'
import Button from '../basic/button'
import EventCarousel from './event_carousel'
import Form from '../form'

function Event(props) {
	let fields = props.fields
	let date
	let time
	
	const renderedComponents = []

	each(props.fields?.event_grid, (component, i) => {
		const type = component.name

		let renderedComponent = null
		if (library[type]) {
			const Component = library[type];
			renderedComponent = <Component key={`component_${type}_${i}`} {...component} />
		} else {
			console.log('Component type not found in library')
		}

		if (renderedComponent) {
			renderedComponents.push(renderedComponent)
		}
	})

	fields.presenters = fields.presenters || []

	if (fields.event.start_date == fields.event.end_date || new Date(fields.event.start_date * 1000).toLocaleDateString('en-us', {timeZone:"UTC", year:"numeric", month:"long", day:"numeric"}) == new Date(fields.event.end_date * 1000).toLocaleDateString('en-us', {timeZone:"UTC", year:"numeric", month:"long", day:"numeric"})){
		date = new Date(fields.event.start_date).toLocaleDateString('en-us', {year:"numeric", month:"long", day:"numeric"})
	} else {
		date = `${new Date(fields.event.start_date).toLocaleDateString('en-us', {year:"numeric", month:"long", day:"numeric"})} - ${new Date(fields.event.end_date).toLocaleDateString('en-us', {year:"numeric", month:"long", day:"numeric"})}`
	}

	if (fields.event.start_date == fields.event.end_date || new Date(fields.event.start_date * 1000).toLocaleDateString('en-us', {timeZone:"UTC", year:"numeric", month:"long", day:"numeric"}) == new Date(fields.event.end_date * 1000).toLocaleDateString('en-us', {timeZone:"UTC", year:"numeric", month:"long", day:"numeric"})){
		time = new Date(fields.event.start_date).toLocaleTimeString('en-us', {hour: '2-digit', minute:'2-digit'})
	} else {
		time = `${new Date(fields.event.start_date).toLocaleTimeString('en-us', {hour: '2-digit', minute:'2-digit'})} - ${new Date(fields.event.end_date).toLocaleTimeString('en-us', {hour: '2-digit', minute:'2-digit'})}`
	}

	return <div className={styles.event}>
		<h1>{fields.title}</h1>
		<div className={styles.header_wrapper}>
			<div className={classNames(styles.event_wrapper, styles[`count_${fields.presenters?.length}`])}>
				<div className={styles.presenter_image_wrapper}>
					{(fields.include_form && fields.image) && <Image {...fields.image} className={styles.intro_image} />}
					{fields.presenters.map((presenter, i) => {
						return <div>
							{presenter.image &&
								<Image {...presenter.image} className={styles.presenter_image} />
							}
						</div>
					})}
				</div>
				<div className={styles.event_meta_wrapper}>
					<div className={styles.date_type}>{date} | <span className={styles.post_type}>Events</span></div>
					
						{fields.presenters.map((presenter, i) => {
							return <div>
								{(presenter.name) && 
									<div className={styles.presenter_name}>{presenter.name}</div>
								}
								{(presenter.title) && 
									<div className={styles.presenter_title}>{presenter.title}</div>
								}
								{(presenter.company) && 
									<div className={styles.presenter_company}>{presenter.company}</div>
								}
							</div>
						})}

						{fields.category && <div className={styles.category}>{fields.category[0].name}</div>}
						
						{fields.presentation_date_time && 
							<div className={styles.date}>{fields.presentation_date_time}</div>

						}

						{(!fields.presentation_date_time && fields.event.start_date) && 
							<div className={styles.date}>{date} {time != '12:00 AM' && time != '12:00 AM - 11:59 PM' && `| ${time}`}</div>
						}

				</div>
				{fields.subheading &&
					<div className={styles.subheading_wrapper}>
						<p className={styles.subheading} dangerouslySetInnerHTML={{__html: fields.subheading}}></p>
					</div>
				}
			</div>
			<div className={classNames(styles.event_cta_wrapper, fields.include_form && styles.has_form)}>
				{fields.include_form && <>
						<h4>{fields?.form_title || fields.form?.title}</h4>
						<Form fields={fields.form}/>
					</>
				}
				{fields.image && !fields.include_form && <Image {...fields.image} className={styles.image} />}
				{fields.registration_closed && fields.event_link ? 
					<Button fields={{button: {url: fields.event_link, title: `Watch ${fields.category[0].name}`, target: '_blank'}}} button_style='style_1' className={styles.event_cta}></Button>
				:
				fields.event_link &&
					<Button fields={{button: {url: fields.event_link, title: `Register for ${fields.category[0].name}`, target: '_blank'}}} button_style='style_1' className={styles.event_cta}></Button>
				}
			</div>
		</div>
		
		{fields.content && <div className={styles.content} dangerouslySetInnerHTML={{__html: fields.content}}></div>}

		{renderedComponents && <div className={styles.content}>{renderedComponents}</div>}

		{(fields.event.venues.length > 0 && fields.event.venues[0].post_name != "webinar" && fields.event.venues[0].post_name != "online") &&
			<div className={styles.venue_details}>
				<div className={styles.venue_meta}>
					<div className={styles.venue_title}><h3>{fields.event.venues[0].post_title}</h3></div>
					<div className={styles.venue_address}>
						{fields.event.venues[0]?.address}<br/> {fields.event.venues[0]?.city}, {fields.event.venues[0]?.state} {fields.event.venues[0]?.country}
					</div>
					<Button fields={{button: {url: fields.event.venues[0].directions_link, target: '_blank', title: 'Get Directions'}}} button_style='style_1' appearance='solid' color='green' className={styles.directions_cta}></Button>
				</div>
				<div className={styles.map_wrapper}>
					<iframe src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDNsicAsP6-VuGtAb1O9riI3oc_NOb7IOU&q=${fields.event.venues[0].address}`}></iframe>
				</div>
			</div>
		}

		<div className={styles.more_events}>
			<div className={styles.more_events_header}>
				<h2>More Events</h2>
				<Button fields={{button: {url: '/resources/events', title: 'Events Home'}}} button_style='style_2' className={styles.events_home}></Button>
			</div>
			<hr />
			<EventCarousel fields={{items: fields.more_events}}/>
		</div>
	</div>
}

export default Event